module.exports = __webpack_public_path__ + "img/img7.80437625.svg";